export default function () {
  return {
    title: '行选择器',
    type: 'group',
    display: 'accordion',
    collapsed: true,
    items: [
      {
        name: 'showSelect',
        title: '是否开启',
        display: 'inline',
        initialValue: false,
        setter: 'BoolSetter',
        // mutator(value) {
        //   if (!value) {
        //     this.getNode().setPropValue('rowSelection', {});
        //   } else {
        //     this.getNode().setPropValue('rowSelection', {
        //       selectType: 'multiple',
        //     });
        //   }
        // },
        // supportVariable: true,
      },
      // {
      //   type: 'composite',
      //   name: 'rowSelection',
      //   title: '行选择配置',
      //   display: 'plain',
      //   items: [
      //     {
      //       name: 'selectType',
      //       title: '选择类型',
      //       initialValue: 'multiple',
      //       display: 'inline',
      //       // supportVariable: true,
      //       setter: {
      //         componentName: 'RadioGroupSetter',
      //         props: {
      //           options: [
      //             { value: 'multiple', title: '多选' },
      //             { value: 'single', title: '单选' },
      //           ],
      //         },
      //       },
      //       disabled() {
      //         return !this.getProps().getPropValue('showSelect');
      //       },
      //     },
      //     {
      //       name: 'isDisabled',
      //       title: '禁止选择某些行',
      //       display: 'inline',
      //       setter: {
      //         componentName: 'CnJSXSetter',
      //         props:{
      //           usePopup: true,
      //           enableFullscreen:true,
      //           theme:'vs',
      //         },
      //         title: 'React JSX代码',
      //         initialValue: {
      //           type: 'js',
      //           source:
      //             "function isDisabled(row, rowIndex, selectedRowKeys, selectedRowRecords, state) { \n  \n}",
      //           compiled:
      //             'function main(){\n    \n    "use strict";\n\nvar __compiledFunc__ = function isDisabled(row, rowIndex, selectedRowKeys, selectedRowRecords, state) {\n  \n};\n    return __compiledFunc__.apply(this, arguments);\n  }',
      //           error: {},
      //         },
      //       },
      //       disabled() {
      //         return !this.getProps().getPropValue('showSelect');
      //       },
      //     },
      //   ],
      // },
      // {
      //   name: 'allowCrossPage',
      //   title: '是否支持跨页',
      //   display: 'inline',
      //   initialValue: false,
      //   setter: <BoolSetter />,
      //   supportVariable: true,
      //   disabled() {
      //     return !this.getProps().getPropValue('showSelect');
      //   },
      // },
    ],
  };
}
